import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BroadcastControls = ({ 
  isLive, 
  isPaused, 
  onStartBroadcast, 
  onStopBroadcast, 
  onPauseResume,
  listenerCount = 0,
  duration = 0
}) => {
  const formatDuration = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs?.toString()?.padStart(2, '0')}:${mins?.toString()?.padStart(2, '0')}:${secs?.toString()?.padStart(2, '0')}`;
  };

  return (
    <div className="broadcast-controls bg-card rounded-lg border border-border p-6 shadow-soft">
      <div className="controls-header mb-6">
        <div className="flex items-center justify-between mb-4">
          <div className="status-indicator flex items-center gap-3">
            {isLive && (
              <>
                <div className="live-dot w-3 h-3 bg-error rounded-full animate-pulse" />
                <span className="text-sm font-heading font-semibold text-error uppercase tracking-wide">
                  В эфире
                </span>
              </>
            )}
            {!isLive && (
              <span className="text-sm font-heading font-medium text-muted-foreground uppercase tracking-wide">
                Готов к эфиру
              </span>
            )}
          </div>
          
          {isLive && (
            <div className="broadcast-stats flex items-center gap-4">
              <div className="stat-item flex items-center gap-2">
                <Icon name="Users" size={16} color="var(--color-muted-foreground)" />
                <span className="text-sm font-mono text-foreground font-medium">
                  {listenerCount}
                </span>
              </div>
              <div className="stat-item flex items-center gap-2">
                <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
                <span className="text-sm font-mono text-foreground font-medium">
                  {formatDuration(duration)}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="main-control flex flex-col items-center gap-4 mb-6">
        {!isLive ? (
          <Button
            variant="default"
            size="xl"
            onClick={onStartBroadcast}
            iconName="Radio"
            iconPosition="left"
            className="w-full max-w-xs"
          >
            Начать трансляцию
          </Button>
        ) : (
          <div className="live-controls flex items-center gap-3 w-full max-w-md">
            <Button
              variant={isPaused ? "default" : "secondary"}
              size="lg"
              onClick={onPauseResume}
              iconName={isPaused ? "Play" : "Pause"}
              iconPosition="left"
              className="flex-1"
            >
              {isPaused ? 'Продолжить' : 'Пауза'}
            </Button>
            
            <Button
              variant="destructive"
              size="lg"
              onClick={onStopBroadcast}
              iconName="Square"
              iconPosition="left"
              className="flex-1"
            >
              Завершить
            </Button>
          </div>
        )}
      </div>

      <div className="quick-actions grid grid-cols-2 sm:grid-cols-4 gap-3">
        <Button
          variant="outline"
          size="sm"
          iconName="Music"
          iconPosition="left"
          disabled={!isLive}
        >
          Джингл
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          iconName="Volume2"
          iconPosition="left"
          disabled={!isLive}
        >
          Эффекты
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          iconName="UserPlus"
          iconPosition="left"
          disabled={!isLive}
        >
          Со-хост
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          iconName="Share2"
          iconPosition="left"
          disabled={!isLive}
        >
          Поделиться
        </Button>
      </div>
    </div>
  );
};

export default BroadcastControls;